import { UseQueryResult, useQuery } from "react-query";
import useUserState from "ui/adapter/state/useUserState";
import useSelectedOrganizationAddress from "ui/role/hooks/useSelectedOrganizationAddress";
import { Queries } from "ui/query/queries";
import type { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { default as config } from "common/config/config";
import { organizationApi } from "../api/organizationApi";

export default function useGetOrganizationBalance<TData = string>({
    enabled: enableProp = true,
    ...options
}: UseCustomQueryOptions<string, unknown, TData, (string | undefined)[]> = {}): UseQueryResult<TData> {
    const { selectedRole } = useUserState();
    const resourceAddress = selectedRole?.resourceAddress;
    const address = useSelectedOrganizationAddress();
    const safeAddress = address as string;

    return useQuery(
        [Queries.ORGANIZATION_BALANCE, resourceAddress, address],
        async () => {
            const res = await organizationApi.getBalance(safeAddress);
            return res.data;
        },
        {
            enabled: enableProp && Boolean(address),
            refetchInterval: config.refetchIntervals.balance,
            ...options,
        },
    );
}
